const isDev = window.location.host.indexOf("localhost") > -1;
// export const BASE_HOST = isDev ? "https://baoxian.pingan.com" : `${window.location.origin}`;
export const BASE_HOST = isDev ? "https://dmzstg1.pa18.com" : `${window.location.origin}`;
// export const BASE_HOST = isDev ? "https://dmzstg2.pa18.com" : `${window.location.origin}`;
interface spzSwAndtidAndTokenType {
  spzSw: boolean;
  tid: string;
  token: string;
}
// TODO  调测
// export const BASE_HOST = "//dmzstg1.pa18.com";
// export const BASE_HOST = "//baoxian.pingan.com";
interface GlobalData {
  effectiveDateFlag: boolean;
  dpt: {};
  flowId: string;
  isShowTargetForm: string[];
  aliProductCodes: string[];
  persionListRule:string,
  productCode: string;
  productName: string;
  appProductInfo: {};
  selectedSet: number;
  planInfo: {};
  quoteInfo: {};
  gUrlData: {};
  userEmail: string;
  maxPersonName: boolean;
  totalNumber: number;
  columIndex: number;
  excludeFlag: boolean;
  dutyList: any[];
  defaultAddress: string[];
  applicant: {};
  langData:{},
  isFirstPeople: boolean;
  noclaimInfo: any;
  specialInfo: any;
  targetFormList: any[],
  planDuty: any[],
  locationTypeToRisks: any[],
  isReadInsurancePolicy: boolean,
  planCheckboxOptions: any[],
  selectedCheckbox: any[],
  needKnow: {},
  sellingAreaOptions: any[],
  targetInfo: {},
  timeStr: string,
  templateVersionFlag: boolean,
  spzSwAndtidAndToken: spzSwAndtidAndTokenType,
  aliPolicyInfo: {},
  groupNameCheckResult: {};
  beginDate: string;
  endDate: string;
  teamIndustryList: any[];
  healthResult: string;
  detalFormStartTime: number;
  teamAccidentProds: string[];
}

export const globalData: GlobalData = {
  effectiveDateFlag: false,
  dpt: {}, // 地区departCode映射
  flowId: "", // 全局flowId
  isShowTargetForm: ["P060017", "P060029", "P060031", "P060032", "P060033", "P060034", "P060037","P060038"],
  aliProductCodes: ["P060088", "P060089", "P060090", "P060091", "P060092"],
  // 清单名称，acplPersonnelList：意健，personnelList:雇主或一般
  // 清单名称可以根据后端接口saveApplyInfo接口返回的persionListRule区分或者自己计算
  // persionListRule: 01不用 02雇主 03意健 04一个人意健
  persionListRule:"01",
  productCode: "", // 全局产品代码
  productName: "", // 全局产品名称
  appProductInfo: {}, // 初始化后产品信息getProductInfo接口获取
  selectedSet: 0, // 全局套餐变量
  planInfo: {}, // 全局的投保种类信息
  quoteInfo: {}, // 报价返回信息
  gUrlData: {}, // url链接信息对象
  userEmail: "", // 初始化的邮箱参数
  maxPersonName: false, // 判断投保人数是否正常
  totalNumber: 0, // 雇员总人数
  columIndex: 1, // 报价页面表格第几列
  excludeFlag: false, // 判断地区属于产品有效地区
  dutyList: [], // 产品所有责任的数组
  defaultAddress: ["310000_上海市", "310100_上海市", "310119_南汇区"], // 默认城市地区
  applicant: {}, // 投保人信息
  langData:{}, // 语言包
  isFirstPeople: true, // “一类职业”雇员人数未改变前使用接口的最小值作为“一类职业”人数默认值
  noclaimInfo: [], // 免赔
  specialInfo: [], // 特约
  targetFormList: [], // 标旳信息
  planDuty: [],
  locationTypeToRisks: [],
  isReadInsurancePolicy: false,
  planCheckboxOptions: [
    { value: "PL1000002", label: "财产一切险" },
    { value: "PL1800205", label: "团体意外险" },
    { value: "PL1000006", label: "公众责任保险" }
  ],
  selectedCheckbox: [],
  needKnow: {
    needKnowKeyOne: "",
    needKnowKeyTwo: ""
  },
  sellingAreaOptions: [
    { label: "1000㎡及以下", value: "01" },
    { label: "1000㎡-2000㎡", value: "02" },
    { label: "2000㎡-3000㎡", value: "03" }
  ],
  targetInfo: {}, // P060030专用标的信息
  timeStr: "",
  templateVersionFlag: false, // 职业分类表 true为22版本 false为12版
  spzSwAndtidAndToken: { spzSw: false, tid: "", token: "" },
  aliPolicyInfo: {
    applyNo: "",
    tableData: [], // 当前套餐数据
    isAuthorize: false,
    groupCertificateNo: "",
    groupCompanyAddress: "",
    groupCompanyName: "",
    industryType: [],
    industryTypeName: []
  },
  groupNameCheckResult: {
    resultCode: "00", // 00-待校验 01-当前企业名称已领取过赠险 02-applyNo未使用且该企业可以投保 03-applyNo已使用
    message: ""
  },
  beginDate: "",
  endDate: "",
  teamIndustryList: [],
  healthResult: "R", // R 待健告 A 完全符合 C 部分符合
  detalFormStartTime: 0,
  teamAccidentProds: ["P040032", "P040033"]
};
